/* eslint react-hooks/exhaustive-deps: 0 */
import { useState, useEffect, useCallback, useContext } from 'react';
import axios from 'axios';
import useAuthToken from './useAuthToken';
import env from '../config/environment';
import { ErrorContext, AppContext } from '../context';
import useCache from './useCache';
import {} from '../config/endpoints';

const lgpdError = ({ method, url }) =>
  method === 'get' && url.includes('consentimentos/processo-negocio');

const useAjaxRequest = (
  itemName,
  cacheConfig = {
    shouldCache: false,
    isCacheValid: () => false,
  },
  options = '',
  initialValue = {}
) => {
  const [response, setResponse] = useState({
    data: initialValue,
    loading: !!options,
    error: null,
  });
  const [lastOptions, setLastOptions] = useState(options);
  const { token, refreshToken } = useAuthToken();
  const { setContext: setErrorContext } = useContext(ErrorContext);
  const { ibcLogged } = useContext(AppContext);
  const [retry, setRetry] = useState(0);
  const { isCached, putCache, getCache } = useCache(itemName);
  const performRequest = useCallback(
    async (asyncOptions = options, accessToken = token) => {
      if (ibcLogged === undefined) {
        return {};
      }
      setLastOptions(asyncOptions);
      try {
        if (!accessToken) {
          return {};
        }
        if (
          isCached &&
          cacheConfig.isCacheValid(getCache(), asyncOptions, token)
        ) {
          const { data } = getCache();
          setResponse({
            data,
            loading: false,
          });
          return data;
        }

        setResponse({
          ...response,
          loading: true,
        });
        const { data } = await axios.request({
          ...asyncOptions,
          headers: {
            ...asyncOptions.headers,
            Authorization: `Bearer ${accessToken}`,
            'x-ibm-client-id': ibcLogged ? env.CLIENT_ID_IBC : env.CLIENT_ID,
            'content-type': 'application/json',
            'X-Robots-Tag': env.ROBOTS,
          },
        });

        if (cacheConfig.shouldCache) {
          putCache(data, {
            ...asyncOptions,
          });
        }

        setResponse({
          data,
          loading: false,
        });

        return data;
      } catch (err) {
        if (
          err.response &&
          err.response.status === 401 &&
          retry < parseInt(env.MAX_RETRY, 10)
        ) {
          setRetry(retry + 1);
          return refreshToken();
        }
        setResponse({
          ...response,
          loading: false,
          error: err,
        });
        if (!lgpdError(asyncOptions)) {
          setErrorContext({
            show: true,
          });
        }
      }
      return {};
    },
    [options, token, refreshToken, isCached, ibcLogged]
  );

  useEffect(() => {
    if (options || lastOptions) {
      performRequest(lastOptions);
    }
  }, [performRequest, options]);

  return { performRequest, response };
};
export default useAjaxRequest;
